/** Do not display an internal payload when the model emits invalid JSON. */
export function memberSummaryNarrative(text: string): string | null {
  const heading = /^(?:\s*#{1,6}\s*|\s*\*\*)Congressional Portfolio(?:\*\*)?[^\n]*$/im.exec(text);
  let narrative = text;
  if (heading) {
    const payload = text.slice(heading.index + heading[0].length).replace(/```(?:json)?/gi, '').trim();
    try {
      const portfolio = JSON.parse(payload);
      if (!portfolio || typeof portfolio !== 'object' || Array.isArray(portfolio)) return null;
    } catch { return null; }
    narrative = text.slice(0, heading.index);
  }
  if (/```|"portfolio_stats"|"representative_bills"|\.\.\.\s*\(/i.test(narrative)) return null;
  return narrative.replace(/^(?:\s*#{1,6}\s*|\s*\*\*)Legislative Summary(?:\*\*)?[^\n]*\n?/im, '').trim() || null;
}
export function memberPortfolioFigures(stats: Record<string, unknown>) {
  const count = (key: string): number | null => {
    const value = stats[key];
    return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : null;
  };
  const total = count('bill_count'), sponsored = count('sponsored_count'), cosponsored = count('cosponsored_count');
  if (total === null || sponsored === null || cosponsored === null || sponsored + cosponsored !== total) return null;
  const evaluated = count('associated_bills_evaluated'), bipartisan = count('bipartisan_count');
  return { total, sponsored, cosponsored,
    sponsoredShare: total ? (100 * sponsored / total).toFixed(1) : null,
    cosponsoredShare: total ? (100 * cosponsored / total).toFixed(1) : null,
    evaluated, bipartisan: evaluated !== null && bipartisan !== null && bipartisan <= evaluated ? bipartisan : null };
}
